export default __webpack_public_path__ + "static/media/facebook.b34c268b.svg";